import React from 'react';
import {Link, NavLink, Route, Routes} from "react-router-dom";
import {withRouter} from "../withRouter";

class Subscribers extends React.Component {
    render() {
        return <div>
            <br/>
            {this.props.subscribers.map(subscriber => (
                <div class="alert alert-dark row" id={subscriber.user.id}>
                    <div>
                        <NavLink to={{
                            pathname: '/customer/' + subscriber.user.id.toString(),
                        }} style={{
                            textDecoration: "none",
                            color: "white"
                        }}>
                            {subscriber.user.first_name} {subscriber.user.last_name}
                        </NavLink>
                    </div>
                </div>
            ))}
            <br/>
        </div>;
    }
}

export default withRouter(Subscribers);
